import {apiFuns} from "sw-hic"
let {genStandard} = apiFuns
const api = {
  Consultation: genStandard("consultation", "/api/ip"),
  Hospitalization: genStandard("hospitalization", "/api/ip"),
}
export default api;